module.exports = __webpack_public_path__ + "img/logo-pt2.eabcdd19.png";